module.exports = __webpack_public_path__ + "static/img/result_main_banner.c3eda1d5.png";